// eslint-disable-next-line import/prefer-default-export
export function setBodyScrollOverflow(hidden) {
  if (hidden) {
    document.documentElement.style.overflow = 'hidden';
  } else {
    document.documentElement.style.overflow = '';
  }
}
